<template>
    <div id="contenedro-principal-modulos-gestionAudiencias" class="container-fluid">
        <div id="encabezados-tp">
            <h1>Gestión de audiencias temporal</h1>
            <h3>Modulos</h3>
        </div>
        <div class="row">
            <div v-for="(modulo,index) in MODULOS"
                :key="modulo.nombre + index" class="col-xs-3 col-sm-3 col-md-3 col-lg-3 pr-2 pt-4"
                @click="irAModulo(modulo)" >
                <div class="card contenedor-principal-modulo">
                    <div class="card-body">
                        <div class="d-flex align-items-center justify-content-between flex-wrap">
                            <div class="modulo-titulos">
                                <h4><strong>{{ modulo.nombre }}</strong></h4>
                                <h6 style="margin-top: -10px !important;">{{ modulo.descripcion }}</h6>
                            </div>
                            <div class="i-modulo">
                                <i :class="modulo.icono"></i>
                            </div>
                        </div>
                    </div>
                    <div class="card-footer">
                        <div class="d-flex justify-content-end">
                            <button type="button" @click="irAModulo(modulo)" class="btn btn-sm btn-dark">ir a {{ modulo.nombre }}&nbsp;&nbsp;<i class="fas fa-chevron-circle-right"></i></button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            MODULOS: [
                { nombre: 'Control', nombrePath: 'ProgramacionAudienciasTemporal', icono: 'fas fa-calendar-alt', descripcion: 'Control de audiencias' },
                { nombre: 'Manejo', nombrePath: 'ManejoTemporal', icono: 'fas fa-calendar-alt', descripcion: 'Manejo de audiencias' },
                { nombre: 'Registro', nombrePath: 'RegistroAudienciasTemporal', icono: 'fas fa-plus', descripcion: 'Registro de audiencias' },
                { nombre: 'Consulta Juez', nombrePath: 'ConsultaJuezAudienciasTemporal', icono: 'fas fa-search', descripcion: 'Consulta de audiencias por juez' },
                { nombre: 'Consulta Administración', nombrePath: 'ConsultaAdministracionAudienciasTemporal', icono: 'fas fa-search', descripcion: 'Consulta para administración' },
                { nombre: 'Lista Audiencias', nombrePath: 'ListaAudienciasAudienciasTemporal', icono: 'fas fa-list', descripcion: 'Listado de audiencias' },
                { nombre: 'Control Auxiliar', nombrePath: 'AgendaControlAuxAudienciasTemporal', icono: 'fas fa-calendar-alt', descripcion: 'Control de audiencia auxiliar' }
            ]
        }
    },
    methods: {
        irAModulo: function({ nombrePath }) { debugger
            this.$router.push({ name: nombrePath });
        }
    }
}
</script>
<style scoped>
@media (max-width: 1000px) {
    .modulo-titulos h6 {
        font-size: 1em !important;
    }

    .modulo-titulos h4 {
        font-size: 1.5em !important;
    }

    .i-modulo i {
        font-size: 1em !important;
    }
}
.contenedor-principal-modulo {
    cursor: pointer;
    opacity: 0.9;
}

.contenedor-principal-modulo:hover,
.contenedor-principal-modulo:focus {
    opacity: 1;
}
/* ========== TITULOS ============== */
#encabezados-tp {
    margin-bottom: 2em;
}

#encabezados-tp h1 {
    margin-bottom: 0;
    font-weight: bold;
    font-size: 2.5em;
}

#encabezados-tp h3 {
    font-size: 1.5em;
    color: rgb(175, 175, 175);
}

#encabezados-tp h4 {
    font-size: 1.5em;
    color: rgb(214, 214, 214);
}

.modulo-titulos h6 {
    color: rgb(179, 179, 179) !important;
}

.i-modulo i {
    font-size: 2em !important;
}

#contenedro-principal-modulos-gestionAudiencias {
    padding: 3em 3em 3em 3em;
}

#contenedro-principal-modulos-gestionAudiencias .card-body {
    background-color: #323335;
}

#contenedro-principal-modulos-gestionAudiencias .card {
    border: 1px solid rgb(129, 129, 129) !important;
}

#contenedro-principal-modulos-gestionAudiencias .card-header {
    background-color: rgb(80, 80, 80);
}

#contenedro-principal-modulos-gestionAudiencias .card-footer {
    padding: 0.5em 0.5em 0.5em 0.5em !important;
    background-color: rgb(143, 143, 143);
}
</style>


// WEBPACK FOOTER //
// src/components/Audiencias/Menu/CMenuModulos.vue